import React, { useEffect } from 'react'
import { Typography, Box, withStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import {
  ProgressBar,
  PROGRESS_BAR_STYLES,
} from 'src/components/wait-screen'
import useBlendedCourseProgress from 'src/pages/ai-course-creation/components/course-creation-step/hooks/useBlendedCourseProgress'
import styles from './styles'

const LoadingView = ({ classes, mode = 'quiz' }) => {
  const isPage = mode === 'page'
  const isActive = useSelector(state => state.course.cardCreationProgress)
  const realProgress = useSelector(
    state => state.course.cardCreationProgressValue,
  )

  const {
    displayedProgress,
    consumeBackendProgress,
  } = useBlendedCourseProgress(!!isActive)

  useEffect(() => {
    if (!isActive) return
    // The polled `cardCreationProgress` reflects overall course completion
    // (including existing cards), not per-generation progress, so we ignore
    // interim values and only forward the completion signal. Dummy progress
    // drives the bar until the backend reports >= 100, then the hook ramps
    // smoothly to 100%.
    if (realProgress >= 100) {
      consumeBackendProgress({ cardCreationProgress: 100 })
    }
  }, [isActive, realProgress, consumeBackendProgress])

  return (
    <div className={classes.loadingContainer}>
      <style>{PROGRESS_BAR_STYLES}</style>
      <img
        src="/assets/new_mascot_noline_1.gif"
        height={200}
        style={{ margin: '0 auto' }}
      />
      <Box m={0.5} />
      <Typography
        fontSize="18px"
        fontWeight={500}
        className={classes.loadingTitle}
      >
        {isPage
          ? 'Generating Your Page with AI…'
          : 'Generating Your Quiz with AI…'}
      </Typography>
      <Typography
        fontSize="14px"
        fontWeight={400}
        className={classes.loadingSubtitle}
      >
        {isPage
          ? "Sit tight! We're using AI magic to generate the best page for you. The window will close automatically when it's ready. 🚀"
          : "Sit tight! We're using AI magic to generate the best quiz for you. The window will close automatically when it's ready. 🚀"}
      </Typography>
      <Box m={1} />
      <div className={classes.progressWrapper}>
        <ProgressBar progress={displayedProgress} />
      </div>
    </div>
  )
}

export default withStyles(styles)(LoadingView)
